import type { AxiosRequestConfig } from 'axios';

import { api } from './init';
import type { IHttpResponse } from './types';

const post = async (
  url: string,
  body: any,
  config?: AxiosRequestConfig
): Promise<IHttpResponse> => {
  try {
    const result = await api.post(url, body, config);
    return { success: true, data: result.data };
  } catch (error) {
    return { success: false, error };
  }
};

export default post;
